/*
=========================================================
ASSABOOR ENTERPRISE
AJAX CART DRAWER V2.2
File: assets/ae-cart-drawer.js
=========================================================
*/

(() => {

'use strict';

class AECartDrawer {

constructor() {

this.drawer=document.querySelector(
'[data-ae-cart-drawer]'
);

if(!this.drawer){
return;
}

this.shell=this.drawer.closest(
'[data-ae-cart-drawer-shell]'
);

this.overlay=document.querySelector(
'[data-ae-cart-drawer-overlay]'
);

this.errorBox=this.drawer.querySelector(
'[data-ae-cart-drawer-error]'
);

this.isUpdating=false;

this.noteTimer=null;

this.lastFocusedElement=null;

this.bindEvents();

}

bindEvents(){

document.addEventListener(
'click',
this.handleDocumentClick.bind(this)
);

document.addEventListener(
'change',
this.handleDocumentChange.bind(this)
);

document.addEventListener(
'input',
this.handleDocumentInput.bind(this)
);

document.addEventListener(
'keydown',
this.handleKeydown.bind(this)
);

document.addEventListener(
'ae:cart:drawer:open',
()=>{
this.open();
}
);

document.addEventListener(
'ae:cart:drawer:close',
()=>{
this.close();
}
);

document.addEventListener(
'ae:cart:drawer:refresh',
async()=>{
await this.refresh();
}
);

/* ======================================================
LIVE CART UPDATE
====================================================== */

document.addEventListener(
'ae:cart:added',
async(event)=>{

const count=
event.detail?.cart?.item_count ??
event.detail?.item_count;

if(Number.isFinite(Number(count))){
this.updateCartCount(count);
}else{
await this.syncCartCount();
}

await this.refresh();

this.open();

}
);

document.addEventListener(
'ae:cart:updated',
async(event)=>{

const count=
event.detail?.cart?.item_count ??
event.detail?.item_count;

if(Number.isFinite(Number(count))){
this.updateCartCount(count);
}else{
await this.syncCartCount();
}

if(event.detail?.skipDrawerRefresh){
return;
}

await this.refresh();

}
);

}

/* ======================================================
CLICK HANDLER
====================================================== */

handleDocumentClick(event){

/* ---------- CLOSE DRAWER ---------- */

const closeTrigger=event.target.closest(
[
'[data-ae-cart-close]',
'.ae-cart-drawer__close',
'[data-ae-cart-drawer] button[aria-label*="close" i]'
].join(',')
);

const overlayTrigger=event.target.closest(
'[data-ae-cart-drawer-overlay]'
);

if(closeTrigger || overlayTrigger){

event.preventDefault();

event.stopPropagation();

this.close();

return;

}

/* ---------- OPEN DRAWER ---------- */

const openTrigger=event.target.closest(
[
'[data-ae-cart-open]',
'[data-cart-open]',
'[data-ae-drawer-trigger]',
'a[href="/cart"]',
'a[href^="/cart?"]',
'a[href$="/cart"]',
'button[aria-label*="cart" i]',
'a[aria-label*="cart" i]'
].join(',')
);

const isDrawerPageLink=
openTrigger?.closest(
'[data-ae-cart-drawer]'
)
&&
(
openTrigger.matches(
'.ae-cart-drawer__view-cart'
)
||
openTrigger.hasAttribute(
'data-ae-cart-page-link'
)
);

if(openTrigger && !isDrawerPageLink){

event.preventDefault();

this.refresh({
preserveOpenState:false
}).finally(()=>{

this.open();

});

return;

}

/* ---------- REST OF FUNCTION CONTINUES ---------- */

const drawer=event.target.closest(
'[data-ae-cart-drawer]'
);

if(!drawer){
return;
}

const item=event.target.closest(
'[data-ae-cart-item]'
);

if(!item){
return;
}

/* -------------------------
MINUS
-------------------------- */

if(
event.target.closest(
'[data-ae-cart-qty-minus]'
)
){

event.preventDefault();

const input=item.querySelector(
'[data-ae-cart-qty-input]'
);

if(!input){
return;
}

const quantity=Math.max(
0,
this.normaliseQuantity(input.value)-1
);

this.changeItem(
item,
quantity
);

return;

}

/* -------------------------
PLUS
-------------------------- */

if(
event.target.closest(
'[data-ae-cart-qty-plus]'
)
){

event.preventDefault();

const input=item.querySelector(
'[data-ae-cart-qty-input]'
);

if(!input){
return;
}

const quantity=
this.normaliseQuantity(
input.value
)+1;

this.changeItem(
item,
quantity
);

return;

}

/* -------------------------
REMOVE
-------------------------- */

if(
event.target.closest(
'[data-ae-cart-remove]'
)
){

event.preventDefault();

this.changeItem(
item,
0
);

}

}

/* =====================================================
INPUT EVENTS
===================================================== */

handleDocumentChange(event){

const input=event.target.closest(
'[data-ae-cart-drawer] [data-ae-cart-qty-input]'
);

if(!input){
return;
}

const item=input.closest(
'[data-ae-cart-item]'
);

if(!item){
return;
}

this.changeItem(
item,
this.normaliseQuantity(
input.value
)
);

}

handleDocumentInput(event){

const note=event.target.closest(
'[data-ae-cart-drawer] [data-ae-cart-note]'
);

if(!note){
return;
}

clearTimeout(
this.noteTimer
);

this.noteTimer=setTimeout(()=>{

this.updateNote(
note.value
);

},650);

}

handleKeydown(event){

if(
event.key==='Escape'
&&
this.isOpen()
){

this.close();

}

}

/* =====================================================
CHANGE ITEM
===================================================== */

async changeItem(item,quantity){

if(this.isUpdating){
return;
}

const key=this.getItemKey(
item
);

if(!key){

this.showError(
'Unable to identify cart item.'
);

return;

}

this.isUpdating=true;

this.clearError();

this.setLoading(true);

item.classList.add(
'is-loading'
);

try{

const response=await fetch(

window.routes?.cart_change_url
||
'/cart/change.js',

{

method:'POST',

headers:{

'Content-Type':'application/json',

Accept:'application/json'

},

body:JSON.stringify({

id:key,

quantity

})

}

);

const cart=
await this.parseResponse(
response
);

if(!response.ok){

throw new Error(

cart.description
||
cart.message
||
'Cart update failed.'

);

}

/* UPDATE HEADER BADGE */

this.updateCartCount(
cart.item_count
);

document.dispatchEvent(

new CustomEvent(

'ae:cart:updated',

{

detail:{

cart,

source:'cart-drawer',

skipDrawerRefresh:true

}

}

)

);

await this.refresh({

preserveOpenState:true

});

}catch(error){

console.error(error);

this.showError(

error.message
||
'Unable to update cart.'

);

}finally{

item.classList.remove(
'is-loading'
);

this.setLoading(false);

this.isUpdating=false;

}

}

/* =====================================================
REFRESH DRAWER
===================================================== */

async refresh(options={}){

const{

preserveOpenState=true

}=options;

const wasOpen=this.isOpen();

try{

const separator=
window.location.search
?
'&'
:
'?';

const response=
await fetch(

`${window.location.pathname}${window.location.search}${separator}section_id=ae-cart-drawer`,

{

headers:{
Accept:'text/html'
}

}

);

if(!response.ok){

throw new Error(
'Unable to refresh drawer.'
);

}

const html=
await response.text();

const parser=
new DOMParser();

const doc=
parser.parseFromString(
html,
'text/html'
);

const newShell=
doc.querySelector(
'[data-ae-cart-drawer-shell]'
);

if(
!newShell
||
!this.shell
){

throw new Error(
'Drawer markup missing.'
);

}

this.shell.replaceWith(
newShell
);

this.shell=newShell;

this.drawer=
newShell.querySelector(
'[data-ae-cart-drawer]'
);

this.overlay=
newShell.querySelector(
'[data-ae-cart-drawer-overlay]'
);

this.errorBox=
newShell.querySelector(
'[data-ae-cart-drawer-error]'
);

if(
preserveOpenState
&&
wasOpen
){

this.open(false);

}

}catch(error){

console.error(error);

this.showError(
error.message
);

}

}

/* =====================================================
UPDATE CART NOTE
===================================================== */

async updateNote(note){

try{

const response=await fetch(

window.routes?.cart_update_url
||
'/cart/update.js',

{

method:'POST',

headers:{

'Content-Type':'application/json',

Accept:'application/json'

},

body:JSON.stringify({

note

})

}

);

const cart=
await this.parseResponse(
response
);

if(!response.ok){

throw new Error(

cart.description
||
cart.message
||
'The order note could not be saved.'

);

}

this.updateCartCount(
cart.item_count
);

document.dispatchEvent(

new CustomEvent(

'ae:cart:updated',

{

detail:{

cart,

source:'cart-note',

skipDrawerRefresh:true

}

}

)

);

}catch(error){

console.error(
'Assaboor cart note update failed:',
error
);

this.showError(

error.message
||
'The order note could not be saved.'

);

}

}

/* =====================================================
OPEN DRAWER
===================================================== */

open(saveFocus=true){

if(!this.drawer){
return;
}

if(saveFocus){

this.lastFocusedElement=
document.activeElement;

}

this.drawer.classList.add(
'is-open'
);

if(this.overlay){

this.overlay.classList.add(
'is-visible'
);

this.overlay.setAttribute(
'aria-hidden',
'false'
);

}

this.drawer.setAttribute(
'aria-hidden',
'false'
);

document.documentElement.classList.add(
'ae-cart-drawer-open'
);

document.body.classList.add(
'ae-cart-drawer-open'
);

window.requestAnimationFrame(()=>{

const closeButton=
this.drawer.querySelector(

[
'[data-ae-cart-close]',
'.ae-cart-drawer__close',
'button[aria-label*="close" i]'
].join(',')

);

closeButton?.focus({

preventScroll:true

});

});

}

/* =====================================================
CLOSE DRAWER
===================================================== */

close(){

if(!this.drawer){
return;
}

this.drawer.classList.remove(
'is-open'
);

if(this.overlay){

this.overlay.classList.remove(
'is-visible'
);

this.overlay.setAttribute(
'aria-hidden',
'true'
);

}

this.drawer.setAttribute(
'aria-hidden',
'true'
);

document.documentElement.classList.remove(
'ae-cart-drawer-open'
);

document.body.classList.remove(
'ae-cart-drawer-open'
);

if(

this.lastFocusedElement
&&
typeof this.lastFocusedElement.focus==='function'

){

this.lastFocusedElement.focus({

preventScroll:true

});

}

}

/* =====================================================
DRAWER STATE
===================================================== */

isOpen(){

return Boolean(

this.drawer?.classList.contains(
'is-open'
)

);

}

/* =====================================================
ITEM KEY
===================================================== */

getItemKey(item){

return(

item.dataset.key
||
item.getAttribute(
'data-key'
)
||
item.dataset.id
||
item.getAttribute(
'data-id'
)
||
''

).trim();

}

/* =====================================================
NORMALISE QUANTITY
===================================================== */

normaliseQuantity(value){

const quantity=
Number.parseInt(
value,
10
);

if(

!Number.isFinite(quantity)
||
quantity<0

){

return 0;

}

return quantity;

}

/* =====================================================
LIVE HEADER CART COUNT
===================================================== */

updateCartCount(itemCount){

const safeCount=Math.max(

0,

Number.parseInt(
itemCount,
10
)
||
0

);

document
.querySelectorAll(

[
'[data-ae-cart-count]',
'.ae-header__badge'
].join(',')

)
.forEach((counter)=>{

counter.textContent=
String(
safeCount
);

counter.hidden=
safeCount<=0;

counter.setAttribute(

'aria-label',

`${safeCount} item${safeCount===1?'':'s'} in cart`

);

});

}

/* =====================================================
FETCH CURRENT CART COUNT
===================================================== */

async syncCartCount(){

try{

const cartUrl=
window.routes?.cart_url
?
`${window.routes.cart_url}.js`
:
'/cart.js';

const response=
await fetch(

cartUrl,

{

method:'GET',

headers:{

Accept:'application/json'

},

cache:'no-store'

}

);

if(!response.ok){

throw new Error(
'Cart count request failed.'
);

}

const cart=
await response.json();

this.updateCartCount(
cart.item_count
);

return cart;

}catch(error){

console.error(

'Assaboor cart count sync failed:',

error

);

return null;

}

}

/* =====================================================
LOADING STATE
===================================================== */

setLoading(state){

if(!this.drawer){
return;
}

this.drawer.classList.toggle(

'is-loading',

state

);

this.drawer
.querySelectorAll(

[
'[data-ae-cart-qty-minus]',
'[data-ae-cart-qty-plus]',
'[data-ae-cart-qty-input]',
'[data-ae-cart-remove]'
].join(',')

)
.forEach((control)=>{

control.disabled=
state;

});

}

/* =====================================================
SHOW ERROR
===================================================== */

showError(message){

if(

!this.errorBox
&&
this.drawer

){

this.errorBox=
document.createElement(
'div'
);

this.errorBox.className=
'ae-cart-drawer__error';

this.errorBox.dataset.aeCartDrawerError=
'';

this.errorBox.setAttribute(
'role',
'alert'
);

const header=
this.drawer.querySelector(
'.ae-cart-drawer__header'
);

header?.insertAdjacentElement(

'afterend',

this.errorBox

);

}

if(!this.errorBox){
return;
}

this.errorBox.textContent=
message;

this.errorBox.hidden=
false;

}

/* =====================================================
CLEAR ERROR
===================================================== */

clearError(){

if(!this.errorBox){
return;
}

this.errorBox.textContent=
'';

this.errorBox.hidden=
true;

}

/* =====================================================
PARSE RESPONSE
===================================================== */

async parseResponse(response){

const contentType=

response.headers.get(
'content-type'
)

||

'';

if(

contentType.includes(
'application/json'
)

){

return response.json();

}

const text=
await response.text();

return{

message:text

};

}

}

/* =====================================================
INITIALISE DRAWER
===================================================== */

const initialiseCartDrawer=()=>{

if(

window.AECartDrawerInstance
&&
window.AECartDrawerInstance.drawer

){

window.AECartDrawerInstance
.syncCartCount();

return;

}

const instance=
new AECartDrawer();

if(instance.drawer){

window.AECartDrawerInstance=
instance;

instance.syncCartCount();

}

};

/* Shopify theme editor reload support */

document.addEventListener(

'shopify:section:load',

initialiseCartDrawer

);

/* Standard page initialization */

if(

document.readyState===
'loading'

){

document.addEventListener(

'DOMContentLoaded',

initialiseCartDrawer,

{

once:true

}

);

}else{

initialiseCartDrawer();

}

})();